import React from 'react';
import { MDText } from 'i18n-react';

import type { IconComponent } from '@motorway/mw-highway-code';
import { ClockIcon, FiltersIcon, ShieldIcon, TransferIcon } from '@motorway/mw-highway-code';

import BenefitCards from 'Components/StaticPages/ProductPageComponents/BenefitCards/BenefitCards';

import LocalTexts from '../DiscoverMWPay.texts.json';

const LocalT = new MDText(LocalTexts);

export type BenefitsSectionProps = {};

const BenefitIcons: IconComponent[] = [
	<TransferIcon key="TransferIcon" />,
	<ClockIcon key="ClockIcon" filled={false} />,
	<FiltersIcon key="VehicleSteeringWheelIcon" />,
	<ShieldIcon key="LockClosedIcon" />,
];

export const BenefitsSection: React.FC<BenefitsSectionProps> = () => (
	<BenefitCards
		cards={LocalTexts.benefits.cards.map((benefit, index) => ({
			content: <p>{LocalT.translate(`benefits.cards.${index}.content`)}</p>,
			heading: LocalT.translate(`benefits.cards.${index}.heading`),
			icon: BenefitIcons[index],
			id: benefit.heading,
		}))}
		heading={LocalT.translate('benefits.heading')}
		preheading={LocalT.translate('benefits.preheading')}
	/>
);
